import React, { FunctionComponent, useMemo } from "react"
import Upload from "../../../components/Upload/Upload"
import { iArtifact } from "../../../definitions/Artifacts"
import { useSelector } from "../../../store"

interface iProps {
  item?: iArtifact
}

const ArtifactUploads: FunctionComponent<iProps> = ({ item }) => {
  const permissions = useSelector(({ user }) => user.permissions)

  const isAdmin = useMemo(() => {
    return !!permissions?.find((p) => p.name === "Admin.Access")
  }, [permissions])

  return (
    <div className="scrollable">
      <Upload
        name="preview"
        fileCollection="Files_ArtifactsPreview"
        maxFiles={1}
        initialFiles={[item?.preview || ""]}
        fileType={["image/png", "image/jpeg"]}
        label="Upload preview"
      />
      <Upload
        name="mesh"
        maxFiles={1}
        fileCollection="Files_Meshes"
        initialFiles={[item?.mesh || ""]}
        label="Upload mesh"
      />
      {isAdmin && (
        <>
          <Upload
            name="fbx"
            maxFiles={1}
            fileCollection="Files_Meshes"
            initialFiles={[item?.fbx || ""]}
            label="Upload FBX"
          />
          <Upload
            name="albedoMap"
            maxFiles={1}
            fileCollection="Files_ArtifactsTexture"
            initialFiles={[item?.albedoMap || ""]}
            label="Upload Albedo map"
          />
          <Upload
            name="normalMap"
            maxFiles={1}
            fileCollection="Files_ArtifactsTexture"
            initialFiles={[item?.normalMap || ""]}
            label="Upload Normal map"
          />
          <Upload
            name="metalicMap"
            maxFiles={1}
            fileCollection="Files_ArtifactsTexture"
            initialFiles={[item?.metalicMap || ""]}
            label="Upload Metalic map"
          />
          <Upload
            name="aoMap"
            maxFiles={1}
            fileCollection="Files_ArtifactsTexture"
            initialFiles={[item?.aoMap || ""]}
            label="Upload Ambient occlusion map"
          />
          <Upload
            name="glossinessMap"
            maxFiles={1}
            fileCollection="Files_ArtifactsTexture"
            initialFiles={[item?.glossinessMap || ""]}
            label="Upload Glossiness map"
          />
        </>
      )}
    </div>
  )
}

export default ArtifactUploads
